import sanityClient from  "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";


export const client = sanityClient({
    projectId: 'og605rpr' ,
    // 9w8h8c9j
    dataset:'production',
    apiVersion: '2024-10-02',
    useCdn: true,
    token: process.env.REACT__APP_SANITY_TOKEN,

})

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);